<template>
  <div class="home " style="padding-bottom: 120px; padding-top: 50px">
    <b-row class="m-0 pt-3 justify-content-center" style="padding-top: 0px !important;">
       <b-img :src="require(`@/assets/logos/eatDoradoLogo.png`)" width="300px" style="max-width: 90%; height: 190px" fluid alt="eatDorado Logo"></b-img>  
    </b-row>
    <b-row class="m-0 mt-3 justify-content-center" style="padding-top: 0px !important;">
      <h3 class="hover-3 mx-2 text-center custom-nav" @click="loginModal = true"> <strong> Login für Restaurantbetreiber</strong></h3>
    </b-row>
    <b-row class="m-0 pt-3 justify-content-center" style="">
      <b-col cols="12" md="6">
        <div class="m-5">
          <b-row class="m-0 justify-content-center">
            <b-img :src="require(`@/assets/images/undraw_diet.svg`)" style="height: 250px" fluid alt="eatDorado Logo"></b-img>  
          </b-row>
          <h3 class="text-center mt-4">Liste dein Restaurant in der eatDorado App und stelle deine Speisekarte online zur Verfügung.</h3>
        </div>
      </b-col>
      <b-col cols="12" md="6">
        <div class="m-5">
          <b-row class="m-0 justify-content-center">
            <b-img :src="require(`@/assets/images/undraw_searching.svg`)" style="height: 250px" fluid alt="eatDorado Logo"></b-img>  
          </b-row>
          <h3 class="text-center mt-4">Werde von potentiellen Gästen online gefunden.</h3>
        </div>
      </b-col>
      <b-col cols="12" md="6" style="z-index: 101">
        <div class="m-5" >
          <b-row class="m-0 justify-content-center">
            <b-img :src="require(`@/assets/images/undraw_On_the_way.svg`)" style="height: 250px" fluid alt="eatDorado Logo"></b-img>  
          </b-row>
          <h3 class="text-center mt-4">Lasse die Bestellung von deinen Kunden abholen oder liefere sie selbst aus!</h3>
        </div>
      </b-col>
      
    </b-row>
    
    <b-modal id="loginModal" size="" centered v-model="loginModal" title="BootstrapVue" hide-footer hide-header>
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 linear-warning pt-3 pr-3 justify-content-end" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <font-awesome-icon @click="loginModal = false" style="font-size: 37px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 linear-warning justify-content-center" >
        <h2 class="text-center text-dark" >eatDorado Business {{ registerActive ? 'Registrierung' : 'Login' }}</h2>
        </b-row>
        <b-row class="m-0 linear-warning justify-content-center" v-if="registerEmailSent || resetEmailSent">
          <h4 class="text-center text-success">Ihnen wurde eine E-Mail an die Eingetragene Adresse gesendet</h4>
        </b-row>
        <b-row class="m-0 pt-3 linear-warning triangle-modal justify-content-between">
          
        </b-row>
        <b-row class="m-0 justify-content-around" style="position: relative; top: -4vh">
          <b-form @submit.prevent="login" style="width: 90%">
            <!-- <b-form-group
              v-if="registerActive"
              id="input-group-1"
              label="Restaurantname:"
              label-for="input-1"
            >
              <b-form-input
                
                id="input-1"
                v-model="form.name"
                type="text"
                placeholder="Name eingeben"
                required
              ></b-form-input>
              
            </b-form-group> -->
            <b-form-group
              id="input-group-2"
              label="E-Mail-Addresse:"
              label-for="input-2"
            >
              <b-form-input
                :state="!form.email || authError ? false : true"
                id="input-2"
                v-model="form.email"
                type="email"
                placeholder="E-Mail eingeben"
                required
              ></b-form-input>
              <b-form-invalid-feedback :state="authError ? false : null">
                {{authMessage}}
              </b-form-invalid-feedback>
            </b-form-group>
          <b-form-group id="input-group-3" v-if="!resetPassword" label="Passwort" label-for="input-3">
            <b-form-input
              :state="!form.password || authError ? false : true"
              id="input-3"
              v-model="form.password "
              placeholder="Passwort eingeben..."
              type="password"
              required
            ></b-form-input>
            <b-form-invalid-feedback :state="authError ? false : null">
                {{authMessage}}
              </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-if="registerActive && !resetPassword" id="input-group-4" label="Passwort wiederholen" label-for="input-4">
            <b-form-input
              :state="!form.passwordRepeat ? false : true"
              id="input-4"
              v-model="form.passwordRepeat"
              placeholder="Passwort wiederholen..."
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="registerActive && !resetPassword" id="input-group-4" label="Zugangsschlüssel eingeben" label-for="input-4">
            <b-form-input
              :state="!form.betakey || authError ? false : true"
              id="input-4"
              v-model="form.betakey"
              placeholder="Zugangsschlüssel eingeben..."
              type="text"
              required
            ></b-form-input>
            <b-form-invalid-feedback :state="authError ? false : null">
                {{authMessage}}
              </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-if="registerActive" id="input-group-5">
            <b-form-checkbox-group
              :state="!form.checked > 0 ? false : true"
              v-model="form.checked"
              id="checkboxes-4"
              required
            >
              <b-form-checkbox value="me"><a href="/datenschutz" target="_blank">Datenschutz</a> gelesen und akzeptiert</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-row class="justify-content-center m-0 mb-3" v-if="!registerActive && !resetPassword">
            <b-link  @click="resetPassword = true">Passwort vergessen?</b-link>
          </b-row>
          <div v-if="!resetPassword">
            <b-button type="submit" style="width: 100%" size="md" variant="dark">{{ registerActive ? 'registrieren' : 'anmelden' }} <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
            <b-button style="width: 100%" size="md" class="mt-3" variant="outline-dark" @click="registerActive = !registerActive">{{ registerActive ? 'zum Login' : 'Restaurant registrieren' }} </b-button>
          </div>
          <div v-if="resetPassword">
            <b-button type="submit" style="width: 100%" size="md" :disabled="!form.email ? true : false" variant="dark">Passwort zurücksetzen <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
            <b-button style="width: 100%" size="md" class="mt-3" variant="outline-dark" @click="registerActive = false, resetPassword = false">zum Login</b-button>
          </div>
          </b-form>
          
        </b-row>
        
      </div>
    </b-modal>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Homes',
  mixins: [coreData],
  data: () => {
    return {
      resetPassword: false,
      form: {},
      loginModal: false,
      registerActive: false
    }
  },
  components: {
    Footer
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    },
    resetEmailSent(){
      return this.$store.getters.resetEmailSent
    },
    registerEmailSent(){
      return this.$store.getters.registerEmailSent
    }
  },
  mounted(){
    this.$store.commit('updating', false)
    if(localStorage.getItem('token')){
      this.$router.push('/dashboard')
    }
  },
  methods: {
    register(){
      let payload = {
        betakey: this.form.betakey,
        email: this.form.email,
        password: this.form.password
      }
      this.data = this.form
      this.$store.dispatch('signup', payload)
      
    },
    login(){
      if(this.registerActive){
        let payload = {
          betakey: this.form.betakey,
          email: this.form.email,
          password: this.form.password
        }

        this.$store.dispatch('signup', payload)
        
      }else if(!this.registerActive && !this.resetPassword){

        var payload = {
          email: this.form.email,
          password: this.form.password
        }
        this.$store.dispatch('login', payload)
        
      }else if(this.resetPassword){
        this.$store.dispatch('resetPassword', {email: this.form.email})
        
      }
      
    }
  }
}
</script>

<style lang="scss">
  .sub-header {
    position: relative;
    top: -18vh;
  }

  .sub-end {
    position: relative;
    top: -50vh;
    height: 40vh;
  }

  .triangle-modal {
    position: relative;
    top: -1px;
    height: 7vh;
    clip-path: polygon(0 0,0 100%,100% 0,100% 0);
    -webkit-clip-path: polygon(0 0,100% 0,100% 0,0 100%);
  }


  .showcase-invert {
    transition: all .5s;
    padding: 15px;
    border-radius: 5px;
    border: none;
    //box-shadow: 1px 1px 2px rgba(255,255,255,0.05), 1px 1px 2px rgba(0,0,0, .5) !important
    //box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 1px 1px 5px rgba(0,0,0, .5) !important;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
  }

  .brand-header {
    box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(60deg,#26c6da,#00acc1);
    &:hover {
        transform: translate(0, -10px);
    }
  }
</style>